/**
 * Kullanıcıyı bulunduğu sayfaya geri döndürecek giriş linki üretir.
 *
 * Neden gerekli: `LoginForm` giriş başarılı olunca `searchParams.get("redirect")`
 * okuyor ve parametre yoksa `router.replace("/")` çalıştırıyor. Yani görev
 * ortasında (sepet, favori, yorum, AI) giriş isteyen bir yer linki parametresiz
 * verirse kullanıcı giriş sonrası yaptığı işi kaybedip ana sayfaya düşüyor.
 *
 * Konum TIKLAMA ANINDA okunuyor; render sırasında değil. Böylece `usePathname`
 * eklemek gerekmiyor ve sunucu HTML'i ile ilk client render'ı ayrışmıyor
 * (hidrasyon uyuşmazlığı olmaz). Bu yüzden yalnızca olay içinde çağrılmalı —
 * JSX'te doğrudan `href={...}` olarak kullanılmamalı.
 */
export const loginHrefWithRedirect = (target?: string): string => {
  const to =
    target ??
    (typeof window !== "undefined"
      ? `${window.location.pathname}${window.location.search}`
      : "");

  // Ana sayfaya dönmek zaten varsayılan davranış — parametreyi boşuna taşıma.
  return to && to !== "/"
    ? `/auth/login?redirect=${encodeURIComponent(to)}`
    : "/auth/login";
};
